import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ClassesContext, StudentsContext } from "../../../Context";
import useCTX from "../hooks/useCTX";

/**
 * Description placeholder
 * @date 6/14/2023 - 6:04:46 PM
 *
 * @export
 * @param student must have _id, name
 * @param showClasses Boolean Show the classes of the student
 * @returns {*}
 */
export default function StudentLink(props) {
  let { student, showClasses, style, tab="recent", status=false, location=false} = props;
  const {locations} = useCTX()
  
  if (typeof student === "string") return <StringStudent {...props} />;

  if (!student || !student.name) return <React.Fragment>No Student</React.Fragment>;

  let statusColor = {color: "black"}

  if (status && student.status) {
    if (student.status === "New") statusColor.color = "green"
    if (student.status === "Pending") statusColor.color = "GoldenRod"
    if (["Lead","Stopped"].includes(student.status)) statusColor.color = "red"
    
  }

  return (
    <Link to={`/student/${student._id}/${tab}`} className="neat" style={{...style,...statusColor}}>
     
      {student.name},{" "}
      {showClasses && student.classes ? (
        <Classes classes={student.classes} location={location} locations={locations} />
      ) : (
        ""
      )}
    </Link>
  );
}

function StringStudent(props) {
  
  let { student, showClasses, style } = props;
  let { findStudent} = useContext(StudentsContext);
  let st = findStudent(student)

  return (
    <Link to={`/student/${student}`} className="neat" style={style}>
      {st.name}{" "}
      {showClasses && st.classes ? (
        <Classes classes={st.classes}/>
      ) : (
        ""
      )}
    </Link>
  );
}

function Classes({ classes, location, locations }) {
  return (
    <React.Fragment>
      {classes
        .map(
          (c) =>
            `${c.name} ${
              location && locations.find((l) => l._id === c.managedBy)
                ? locations.find((l) => l._id === c.managedBy).name
                : ""
            }`
        )
        .toString()}
    </React.Fragment>
  );
}

function DrawClass(props) {
  const { classes } = useContext(ClassesContext);

  let sClass = classes.find((c) => c._id && c._id === props.cl);
  if(!sClass) return <>No class</>

  return <React.Fragment>{sClass.name}</React.Fragment>;

 /*  return <FindClass {...props} setClasses={setClasses} classes={classes} />; */
}

/* function FindClass(props) {
  const { classes, setClasses } = props;
  const [cl, setCl] = React.useState(undefined);
  React.useEffect(() => {
    net.get(`/classes/${props.cl}`).then((res) => {
      if (res) {
        setCl((prev) => res);
        setClasses((prev) => [...prev, res]);
      } else {
        setCl({ _id: props.cl, name: "Class Deleted" });
        if (!classes.find((c) => c._id === props.cl)) {
          setClasses((prev) => [
            ...prev,
            { _id: props.cl, name: "Class Deleted" },
          ]);
        }
      }
    });
  }, []);
  if (!cl) return <React.Fragment></React.Fragment>;
  return <React.Fragment>{cl.name}</React.Fragment>;
}
 */